import { lazy } from "react";

// OpenID disabled — no longer supported
// const AuthCallback = lazy(() => import("../modules/Auth/pages/AuthCallback"));

export const Manager = lazy(() => import("../modules/Admin/components/Manager"));
export const CompanyManager = lazy(
  () => import("../modules/Admin/components/Manager/CompanyManager"),
);
export const ServicesManager = lazy(() => import("../modules/Admin/components/ServicesManager"));

export const AdminLegalDocuments = lazy(
  () => import("../modules/Admin/components/Manager/components/legalDocuments"),
);
export const TagsManager = lazy(() => import("../modules/Admin/components/TagsManager"));
export const CurrentLegalNoticeDocument = lazy(
  () => import("../modules/LegalDocuments/CurrentLegalNoticeDocument"),
);
export const CookieSettings = lazy(() => import("../modules/CookieSettings"));

// Lazy load modules for better performance
export const Welcome = lazy(() => import("../modules/Welcome"));
export const DataServices = lazy(() => import("../modules/DataServices"));
export const CustomCatalog = lazy(() => import("../modules/CustomCatalog"));
export const DataDonation = lazy(() => import("../modules/DataDonation"));
export const DataDiscovery = lazy(() => import("../modules/DataDiscovery"));
export const DataStewardship = lazy(() => import("../modules/DataStewardship"));
export const DataStagingTicket = lazy(() => import("../modules/DataStagingTicket"));
export const ServicePage = lazy(() => import("../modules/DataServices/ServicePage"));

// Lazy load pages
export const Docs = lazy(() => import("../modules/Docs"));
export const Login = lazy(() => import("../modules/Auth/pages/Login"));
export const Signup = lazy(() => import("../modules/Auth/pages/Signup"));
export const ForgotPassword = lazy(() => import("../modules/Auth/pages/ForgotPassword"));
export const ResetPassword = lazy(() => import("../modules/Auth/pages/ResetPassword"));
export const Profile = lazy(() => import("../modules/Profile"));
export const AdminDashboard = lazy(() => import("../modules/Admin/components/AdminDashboard"));

export const Projects = lazy(() => import("../modules/Projects"));
export const ProjectDetail = lazy(() => import("../modules/Projects/ProjectDetail"));
export const MyProjects = lazy(() => import("../modules/Projects/MyProjects"));
export const MoveMember = lazy(() => import("../modules/Projects/MoveMember"));
export const TicketsDashboard = lazy(() => import("../modules/Tickets/pages/TicketsDashboard"));
export const MyTicketsDashboard = lazy(() => import("../modules/Tickets/pages/MyTicketsDashboard"));
export const HpcFlows = lazy(() => import("../modules/HpcFlows"));
export const HpcKeys = lazy(() => import("../modules/Admin/components/KeyManagement"));
